import { combineReducers } from 'redux'

import minimal from './put/minimal'
import full from './put/full'

export default combineReducers({
  minimal,
  full
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/products/put.js